module.exports = __webpack_public_path__ + "static/img/1.642ad568.jpg";